import { render, staticRenderFns } from "./BestPrice.vue?vue&type=template&id=2c47e18c&"
import script from "./BestPrice.vue?vue&type=script&lang=js&"
export * from "./BestPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports